import styled, { css } from "styled-components";
import { rgbaToHex } from "../../../../sharable/PickerAndSelector";

export const TakeXPayYPromo = styled.span`
  height: min-content;
  line-height: 1.2;
  padding: 0.5px 4px;
  text-transform: uppercase;
  width: min(100%, var(--main-price-width));
  max-width: var(--main-price-width);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  ${({ canvasScale, styles }) => {
    const fontScale = styles.fontSize * canvasScale;
    const bgColorHex = rgbaToHex(styles.secondaryBgColor, 1);
    const txtColorHex = rgbaToHex(styles.secondaryTxtColor, 1);
    return css`
      font-size: ${fontScale * 2 * 0.4}px;

      .txt {
        text-align: center;
        border-radius: ${10 * canvasScale}px;
        padding: ${canvasScale * 2}px;
        color: ${bgColorHex};
      }

      .txt.take-x {
        width: 70%;
        color: ${txtColorHex};
        width: min(
          ${((Number(styles.fontSize) * 1.4) / 2) * 5 * canvasScale}px,
          var(--main-price-width)
        );
        background-color: ${bgColorHex};
      }

      .txt.pay-y {
        width: 80%;
        background-color: ${txtColorHex};
        width: min(
          ${((Number(styles.fontSize) * 1.6) / 2) * 5 * canvasScale}px,
          var(--main-price-width)
        );
      }
    `;
  }}
`;
